import React, { memo } from 'react';

import SeoTextsBlocks from 'components/SeoTextsBlocks';
import MbPageBreadCrumbs from 'components/MbPageBreadCrumbs';
import Banner from 'components/Banner';

import { BreadCrumbsWrapper } from 'components/FooterStyles';

import { Wrapper } from './styles';

const MbPageFooter = memo(() => (
  <Wrapper>
    <SeoTextsBlocks />

    <BreadCrumbsWrapper>
      <Banner id="rp-react-banner-bottom" slot="bn-slot-bottom" />
      <MbPageBreadCrumbs />
      <Banner id="rp-react-banner-catfish" slot="bn-slot-catfish" />
    </BreadCrumbsWrapper>
  </Wrapper>
));

export default MbPageFooter;
